import { createStyles } from '@mantine/core';
import themeVariables from '@/styles/themeVariables';

export const useTechblogListPageStyle = createStyles((theme) => ({
  sidePanelContainer: {
    [theme.fn.largerThan('lg')]: {
      maxWidth: 440,
    },
  },

  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    columnGap: 15,
    padding: '12px 6px',
  },

  headerTitleImage: {
    width: 24,
    height: 24,
  },

  headerTitle: {
    fontWeight: 600,
    fontSize: 16,
    color: themeVariables.fontColors.medium,
  },

  headerArrow: {
    marginLeft: 'auto',
    '& svg': {
      verticalAlign: 'middle',
    },
  },

  searchBoxContainer: {
    padding: '12px 0px',
  },

  searchBoxRecommendedTagTitle: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
    columnGap: 8,
    fontSize: 14,
    fontWeight: 600,
    color: themeVariables.fontColors.medium,
  },

  searchBoxTagContainer: {
    marginTop: 20,
    display: 'flex',
    gap: 6,
    flexWrap: 'wrap',
  },

  searchBoxKeywordTabButtonContainer: {
    display: 'flex',
    marginTop: 12,
    placeContent: 'flex-end',
    columnGap: 4,
  },

  popularRankingListContainer: {
    padding: '12px 0px',
  },

  tabContainer: {
    marginBottom: 16,
  },

  tab: {
    color: themeVariables.fontColors.light,
    '&[data-active]': {
      color: '#0064fa',
      backgroundColor: '#eaf5ff',
      fontWeight: 500,
      '&:hover': {
        color: '#0064fa',
        backgroundColor: '#eaf5ff',
        fontWeight: 500,
      },
    },
  },
}));

export const useTechblogCardDesktopStyles = createStyles(
  (theme, dark: any) => ({
    skeletonContainer: {
      padding: 32,
      alignItems: 'center',
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },

    outerContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 12,
      padding: 16,
      width: '100%',
      cursor: 'pointer',
      borderRadius: '16px',
      '&:hover': {
        backgroundColor: dark?.dark
          ? themeVariables.colors.darkHover
          : '#fbfbfb',
      },
      [theme.fn.smallerThan('sm')]: {
        display: 'none',
      },
    },

    logoImage: {
      width: 64,
      height: 64,
      borderRadius: '0.75rem',
      margin: '0px 32px',
      backgroundColor: '#fff',
    },

    descriptionContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: 16,
    },

    title: {
      color: dark?.dark
        ? themeVariables.label.normalDark
        : themeVariables.fontColors.dark,
      wordBreak: 'break-all',
      fontWeight: 600,
      fontSize: 16,
      marginRight: 8,
      verticalAlign: 'middle',
    },

    summary: {
      fontSize: 14,
      marginBottom: 12,
      lineHeight: 1.8,
      wordBreak: 'break-all',
    },

    footerContainer: {
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      rowGap: 8,
      columnGap: 4,
    },

    bookmarkButton: {},

    footerDivider: {
      margin: 6,
    },

    footerDate: {
      fontSize: 14,
      marginLeft: 6,
      color: dark?.dark
        ? themeVariables.label.alternativeDark
        : themeVariables.fontColors.light,
    },

    goodEmoji: {
      background: 'white',
      cursor: 'pointer',
      padding: '3px 8px',
      justifyContent: 'center',
      borderRadius: '4rem',
      color: themeVariables.fontColors.extraLight,
      border: `0.5px solid ${themeVariables.colors.light200}`,
      ':hover': {
        color: themeVariables.fontColors.dark,
        border: `0.5px solid ${themeVariables.colors.light500}`,
        transitionDuration: '0.2s',
      },
    },

    badEmoji: {
      background: 'white',
      cursor: 'pointer',
      padding: '3px 8px',
      justifyContent: 'center',
      borderRadius: '4rem',
      color: themeVariables.fontColors.extraLight,
      border: `0.5px solid ${themeVariables.colors.light200}`,
      ':hover': {
        color: themeVariables.fontColors.dark,
        border: `0.5px solid ${themeVariables.colors.light500}`,
        transitionDuration: '0.2s',
      },
    },
  })
);

export const useTechblogCardMobileStyles = createStyles((theme, dark: any) => ({
  skeletonContainer: {
    padding: 12,
    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
  },

  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 30,
    padding: 8,
    width: '100%',
    cursor: 'pointer',
    borderRadius: '16px',
    '&:hover': {
      backgroundColor: dark?.dark
        ? themeVariables.colors.darkHover
        : themeVariables.colors.light000,
    },
    [theme.fn.largerThan('sm')]: {
      display: 'none',
    },
  },

  appOuterContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    cursor: 'pointer',
    marginBottom: 10,
  },

  logoImage: {
    width: 42,
    height: 42,
    borderRadius: '0.5rem',
  },

  appLogoImage: {
    width: 42,
    height: 42,
    borderRadius: '0.5rem',
    border: `0.5px solid ${themeVariables.colors.light300}`,
  },

  headerContainer: {
    display: 'flex',
    marginBottom: 16,
    alignItems: 'center',
  },

  bookmarkButton: {
    cursor: 'pointer',
    marginLeft: 'auto',
  },

  title: {
    wordBreak: 'break-all',
    fontWeight: 600,
    fontSize: 16,
  },

  summary: {
    fontSize: 13,
    margin: '12px 0px 8px',
    lineHeight: 1.8,
    wordBreak: 'break-all',
  },

  tagContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    rowGap: 6,
    columnGap: 4,
    margin: '4px 0px',
  },

  footerDate: {
    fontSize: 13,
    marginTop: 8,
  },
}));

export const useTechblogListPageSideBoxStyle = createStyles(
  (theme, dark: any) => ({
    cardContainer: {
      padding: 4,
      [theme.fn.smallerThan('sm')]: {
        padding: 0,
      },
    },

    headerContainer: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      columnGap: 15,
      padding: '12px 6px',
      justifyContent: 'space-between',
    },

    headerTitleImage: {
      width: 24,
      height: 24,
    },

    headerTitle: {
      fontWeight: 600,
      fontSize: 16,
      color: dark?.dark
        ? themeVariables.label.normalDark
        : themeVariables.fontColors.medium,
    },

    searchBoxContainer: {
      padding: '12px 0px',
    },

    searchBoxRecommendedTagTitle: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 8,
      columnGap: 8,
      fontSize: 14,
      fontWeight: 600,
      color: dark?.dark
        ? themeVariables.label.normalDark
        : themeVariables.fontColors.medium,
    },

    searchBoxTagContainer: {
      marginTop: 20,
      display: 'flex',
      rowGap: 8,
      columnGap: 6,
      flexWrap: 'wrap',
      minHeight: 50,
    },

    searchBoxKeywordTabButtonContainer: {
      display: 'flex',
      marginTop: 12,
      placeContent: 'flex-end',
      columnGap: 4,
    },

    popularRankingListContainer: {
      padding: '12px 0px',
    },

    tabContainer: {
      marginBottom: 16,
    },

    tab: {
      color: dark?.dark
        ? themeVariables.label.normalDark
        : themeVariables.fontColors.light,
      '&[data-active]': {
        color: '#0064fa',
        backgroundColor: '#eaf5ff',
        fontWeight: 500,
        '&:hover': {
          color: '#0064fa',
          backgroundColor: '#eaf5ff',
          fontWeight: 500,
        },
      },
    },
  })
);
